// storeCreator.ts
import { create, StateCreator, StoreApi, UseBoundStore } from 'zustand'
import { devtools, persist, PersistOptions } from 'zustand/middleware'

type StoreMutators<T> = [['zustand/devtools', never], ['zustand/persist', T]]

/**
 *
 *
 * @param config
 * @param persistOptions
 *
 * @returns
 */

export function createStore<T extends object>(
    config: StateCreator<T, [], []>,
    persistOptions: PersistOptions<T>,
): UseBoundStore<StoreApi<T>> {
    return create<T, StoreMutators<T>>(devtools(persist(config, persistOptions)))
}
